import { PostSearchMatch, PostSearchMatchFilters, QueryResult } from '@/type';
import api from '../../API';

export default {
  findAll(
    searchId: number,
    filters: PostSearchMatchFilters,
  ): Promise<QueryResult<PostSearchMatch>> {
    return api
      .get(`post-searches/${searchId}/matches`, { params: filters })
      .then(response => response.data);
  },
};
